var _path, _path2, _path3, _path4, _path5, _circle, _path6, _g, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgForceUpgradeBackground = function SvgForceUpgradeBackground(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375,
    height: 812,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h375v812H0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 0h375v812H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#A10E20",
    fillRule: "evenodd",
    d: "M216.493 338.294c-5.168 5.167-11.094 9.114-17.42 11.839l-20.764-52.854-52.851-20.763c2.725-6.325 6.671-12.251 11.839-17.418 21.869-21.869 57.326-21.869 79.196 0 21.869 21.869 21.869 57.327 0 79.196Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m184.733 234.287 1.301-1.301c25.056-24.682 58.265-36.12 90.877-34.314 1.823 32.898-9.831 66.404-34.962 91.535-15.456 15.456-34.079 25.814-53.78 31.075l-33.864-33.864c5.187-19.426 15.329-37.804 30.428-53.131Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F87C86",
    fillRule: "evenodd",
    d: "M188.173 321.281c-4.649 1.241-9.357 2.199-14.098 2.873l-22.642-22.642c.674-4.741 1.631-9.449 2.873-14.098l33.867 33.867Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 239.12,
    cy: 239.298,
    r: 14,
    fill: "#A10E20",
    stroke: "#F87C86",
    strokeWidth: 8,
    transform: "rotate(45 239.12 239.298)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 244,
    height: 245,
    x: -83,
    y: 314,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.353 318.663c6.675-5.33 16.289-4.793 22.329 1.247 6.039 6.04 6.576 15.654 1.246 22.328L-4.72833 544.691c-13.39657 16.777-38.40647 18.174-53.58787 2.993l-13.7761-13.776c-15.1813-15.182-13.7846-40.192 2.9927-53.588L133.353 318.663Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.913 323.108c6.675-5.329 16.288-4.792 22.328 1.247 6.04 6.04 6.577 15.654 1.247 22.329L-9.16876 549.136c-13.39654 16.778-38.40654 18.174-53.58784 2.993l-13.7761-13.776c-15.1814-15.181-13.7846-40.191 2.9927-53.588l202.453-161.657Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F87C86",
    d: "M133.555 329.937c3.399-2.957 8.506-2.78 11.692.405 3.185 3.186 3.362 8.293.405 11.692L-38.2091 553.29c-10.6496 12.236-29.4377 12.887-40.9083 1.416-11.4705-11.47-10.8199-30.258 1.4165-40.908L133.555 329.937Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A10E20",
    d: "M132.529 337.2c1.636-1.52 4.181-1.473 5.759.106 1.579 1.579 1.626 4.123.107 5.759L-69.0919 566.478c-5.9472 6.403-16.0222 6.59-22.2018.41-6.1796-6.18-5.9935-16.255.4101-22.202L132.529 337.2Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M304.443 412.201c-.261-2.737-2.406-4.917-5.139-5.22l-3.308-.368c-.567-.063-.996-.542-.996-1.113s.429-1.05.996-1.113l3.308-.368c2.733-.303 4.878-2.483 5.139-5.22L304.9 394c.054-.567.53-1 1.1-1 .57 0 1.046.433 1.1 1l.457 4.799c.261 2.737 2.406 4.917 5.139 5.22l3.308.368c.567.063.996.542.996 1.113s-.429 1.05-.996 1.113l-3.308.368c-2.733.303-4.878 2.483-5.139 5.22L307.1 417c-.054.567-.53 1-1.1 1-.57 0-1.046-.433-1.1-1l-.457-4.799ZM121.443 92.2009c-.261-2.7373-2.406-4.9164-5.139-5.2203l-3.308-.3677c-.567-.063-.996-.5424-.996-1.1129s.429-1.0499.996-1.1129l3.308-.3677c2.733-.3039 4.878-2.483 5.139-5.2203l.457-4.7987c.054-.5672.53-1.0004 1.1-1.0004.57 0 1.046.4332 1.1 1.0004l.457 4.7987c.261 2.7373 2.406 4.9164 5.139 5.2203l3.308.3677c.567.063.996.5424.996 1.1129s-.429 1.0499-.996 1.1129l-3.308.3677c-2.733.3039-4.878 2.483-5.139 5.2203l-.457 4.7987c-.054.5672-.53 1.0004-1.1 1.0004-.57 0-1.046-.4332-1.1-1.0004l-.457-4.7987ZM131.028 523.816c-.257-2.606-2.308-4.674-4.912-4.953l-3.199-.343c-.522-.056-.917-.496-.917-1.02s.395-.964.917-1.02l3.199-.343c2.604-.279 4.655-2.347 4.912-4.953l.418-4.229c.054-.542.51-.955 1.054-.955s1 .413 1.054.955l.418 4.229c.257 2.606 2.308 4.674 4.912 4.953l3.199.343c.522.056.917.496.917 1.02s-.395.964-.917 1.02l-3.199.343c-2.604.279-4.655 2.347-4.912 4.953l-.418 4.229c-.054.542-.51.955-1.054.955s-1-.413-1.054-.955l-.418-4.229ZM305.028 702.816c-.257-2.606-2.308-4.674-4.912-4.953l-3.199-.343c-.522-.056-.917-.496-.917-1.02s.395-.964.917-1.02l3.199-.343c2.604-.279 4.655-2.347 4.912-4.953l.418-4.229c.054-.542.51-.955 1.054-.955s1 .413 1.054.955l.418 4.229c.257 2.606 2.308 4.674 4.912 4.953l3.199.343c.522.056.917.496.917 1.02s-.395.964-.917 1.02l-3.199.343c-2.604.279-4.655 2.347-4.912 4.953l-.418 4.229c-.054.542-.51.955-1.054.955s-1-.413-1.054-.955l-.418-4.229ZM42.025 227.679c-.1752-1.734-1.5438-3.108-3.2779-3.29l-2.1491-.225c-.3399-.036-.598-.322-.598-.664s.2581-.628.598-.664l2.1491-.225c1.7341-.182 3.1027-1.556 3.2779-3.29l.2712-2.685c.0365-.361.3407-.636.7038-.636s.6673.275.7038.636l.2712 2.685c.1752 1.734 1.5438 3.108 3.2779 3.29l2.1491.225c.3399.036.598.322.598.664s-.2581.628-.598.664l-2.1491.225c-1.7341.182-3.1027 1.556-3.2779 3.29l-.2712 2.685c-.0365.361-.3407.636-.7038.636s-.6673-.275-.7038-.636l-.2712-2.685Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "m238 101-71 71M205 768l-71 71M380 426l-42 42M36 676l-42 42M206-10l-47 47M21 141l-29 29M228 439l-29 29M270 622l-46 52"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m375 86-29 29"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h375v812H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h375v812H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    x2: 618.159,
    y1: 0,
    y2: 285.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA1C5"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgForceUpgradeBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "force-upgrade-background.e68ac021ec73dcc71fbe00dadd66671e.svg";